import { FilterController } from './class/FilterController'

window.addEventListener('DOMContentLoaded', portfolioController)

function portfolioController() {
  try {
    const properties = document.querySelectorAll('.property__link')
    const controls = document.querySelectorAll('.portfolio__controls')
    const noResults = document.querySelector('#portfolio-empty')
  
    if ( properties && controls ) {
      const controller = new FilterController(properties, controls, noResults)
  
      if ( window.location.search ) {
        const urlParams = new URLSearchParams(window.location.search)
        controller.initialFilter(urlParams)
      }
      
      controller.initializeControls()
    }
  } catch (error) {
    console.log("Portfolio filtering will only occur on front end.")
  }

}

